import Cookies from 'js-cookie';

// Cookie configuration
const COOKIE_CONFIG = {
  // Authentication cookies
  AUTH_TOKEN: '11-267d33f6-2969-42f9-b371-848cbcf8aad1',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  // Cookie options
  DEFAULT_OPTIONS: {
    secure: process.env.NODE_ENV === 'production', // Only send over HTTPS in production
    sameSite: 'strict' as const, // CSRF protection
    expires: 7, // 7 days
  },
  
  // Session cookie options (expires when browser closes)
  SESSION_OPTIONS: {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict' as const,
  },
} as const;

/**
 * Cookie utility functions for authentication
 */
export class CookieUtils {
  /**
   * Set an authentication token cookie
   */
  static setAuthToken(token: string, isSession = false): void {
    console.log('=======token=========');
    console.log(token);
    console.log('=======token=========');

    const options = isSession ? COOKIE_CONFIG.SESSION_OPTIONS : COOKIE_CONFIG.DEFAULT_OPTIONS;
    console.log(COOKIE_CONFIG.AUTH_TOKEN, token, options);
    Cookies.set(COOKIE_CONFIG.AUTH_TOKEN, token, options);
  }

  /**
   * Get the authentication token from cookie
   */
  static getAuthToken(): string | undefined {
    let s =  Cookies.get(COOKIE_CONFIG.AUTH_TOKEN);
    console.log('=====cook==========');
    console.log(s);
    console.log('=====cook==========');
    return s;
  }

  /**
   * Set a refresh token cookie
   */
  static setRefreshToken(token: string, isSession = false): void {
    const options = isSession ? COOKIE_CONFIG.SESSION_OPTIONS : COOKIE_CONFIG.DEFAULT_OPTIONS;
    Cookies.set(COOKIE_CONFIG.REFRESH_TOKEN, token, options);
  }

  /**
   * Get the refresh token from cookie
   */
  static getRefreshToken(): string | undefined {
    return Cookies.get(COOKIE_CONFIG.REFRESH_TOKEN);
  }

  /**
   * Set user data cookie
   */
  static setUserData(userData: any, isSession = false): void {
    const options = isSession ? COOKIE_CONFIG.SESSION_OPTIONS : COOKIE_CONFIG.DEFAULT_OPTIONS;
    Cookies.set(COOKIE_CONFIG.USER_DATA, JSON.stringify(userData), options);
  }

  /**
   * Get user data from cookie
   */
  static getUserData(): any | null {
    const userData = Cookies.get(COOKIE_CONFIG.USER_DATA);
    if (!userData) return null;
    
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error('Failed to parse user data from cookie:', error);
      return null;
    }
  }

  /**
   * Set a custom cookie with options
   */
  static setCookie(
    name: string, 
    value: string, 
    options: {
      expires?: number | Date;
      path?: string;
      domain?: string;
      secure?: boolean;
      sameSite?: 'strict' | 'lax' | 'none';
    } = {}
  ): void {
    const cookieOptions = {
      ...COOKIE_CONFIG.DEFAULT_OPTIONS,
      ...options,
    };
    Cookies.set(name, value, cookieOptions);
  }

  /**
   * Get a custom cookie
   */
  static getCookie(name: string): string | undefined {
    return Cookies.get(name);
  }

  /**
   * Remove a specific cookie
   */
  static removeCookie(name: string, options: { path?: string; domain?: string } = {}): void {
    Cookies.remove(name, options);
  }

  /**
   * Clear all authentication cookies
   */
  static clearAuthCookies(): void {
    Cookies.remove(COOKIE_CONFIG.AUTH_TOKEN);
    Cookies.remove(COOKIE_CONFIG.REFRESH_TOKEN);
    Cookies.remove(COOKIE_CONFIG.USER_DATA);
    // Note: waterat cookie is not cleared as it's required for all API requests
  }

  /**
   * Check if user is authenticated based on cookies
   */
  static isAuthenticated(): boolean {
    return !!this.getAuthToken();
  }

  /**
   * Set authentication data after successful login
   */
  static setAuthData(authData: {
    token?: string;
    refreshToken?: string;
    user: any;
    isSession?: boolean;
  }): void {
    const { token, refreshToken, user, isSession = false } = authData;

    if (token) {
      this.setAuthToken(token, isSession);
    }

    if (refreshToken) {
      this.setRefreshToken(refreshToken, isSession);
    }

    if (user) {
      this.setUserData(user, isSession);
    }
  }

  /**
   * Get all authentication data from cookies
   */
  static getAuthData(): {
    token?: string;
    refreshToken?: string;
    user: any | null;
  } {
    return {
      token: this.getAuthToken(),
      refreshToken: this.getRefreshToken(),
      user: this.getUserData(),
    };
  }

  /**
   * Get the waterat cookie value
   */
  static getWateratCookie(): string | undefined {
    return this.getCookie('waterat');
  }

  /**
   * Set the waterat cookie
   */
  static setWateratCookie(value?: string): void {
    const wateratValue = value || import.meta.env.VITE_WATERAT_COOKIE_VALUE || '11-267d33f6-2969-42f9-b371-848cbcf8aad1';
    this.setCookie('waterat', wateratValue, {
      expires: 7, // 7 days
      path: '/',
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict',
    });
  }
}

// Export individual functions for convenience
export const {
  setAuthToken,
  getAuthToken,
  setRefreshToken,
  getRefreshToken,
  setUserData,
  getUserData,
  setCookie,
  getCookie,
  removeCookie,
  clearAuthCookies,
  isAuthenticated,
  setAuthData,
  getAuthData,
  getWateratCookie,
  setWateratCookie,
} = CookieUtils;

export default CookieUtils;
